module.exports = __webpack_public_path__ + "img/startup-c.ea9950b.svg";